function ErrorPage(container, pageType, templateName) {
  this.$container = $(container);
  this.$contentContainer = this.$container.find(
    templateName == 'sign' ? '.sign-container' : '.content-container',
  );
  this.pageType = pageType;
  this.templateName = templateName;
}

ErrorPage.prototype.centerContent = function () {
  let containerHeight = this.$container.outerHeight() || null,
    contentContainerHeight = this.$contentContainer.outerHeight() || null,
    top = (containerHeight - contentContainerHeight) / 2,
    offset = this.templateName == 'sign' ? -100 : 0;

  // // console.log(this.$contentContainer[0]);
  // // console.log('containerHeight = ' + containerHeight)
  // // console.log('contentContainerHeight = ' + contentContainerHeight)
  // // console.log('top = ' + top)

  this.$contentContainer.css('top', top + offset);
};

ErrorPage.prototype.initialize = function () {
  const self = this;

  this.centerContent();
  this.$container.on('resize', (e) => {
    e.preventDefault();
    e.stopPropagation();
    self.centerContent();
  });

  // fades in content on the plain template
  if (this.templateName == 'plain') {
    window.setTimeout(() => {
      self.$contentContainer.addClass('in');
    }, 500);
  }

  // swings sign in on the sign template
  if (this.templateName == 'sign') {
    $('.sign-container').animate(
      { textIndent: 0 },
      {
        step(now) {
          $(this).css({
            transform: `rotate(${now}deg)`,
            'transform-origin': 'top center',
          });
        },
        duration: 1000,
        easing: 'easeOutBounce',
      },
    );
  }
};

ErrorPage.prototype.createTimeRangeTag = function (start, end) {
  return `<time utime=${start} simple_format="MMM DD, YYYY HH:mm">${start}</time> - <time utime=${end} simple_format="MMM DD, YYYY HH:mm">${end}</time>.`;
};

ErrorPage.prototype.handleStatusFetchSuccess = function (pageType, data) {
  if (pageType == '503') {
    $('#replace-with-fetched-data').html(data.status.description);
  } else if (data.scheduled_maintenances.length) {
    const maint = data.scheduled_maintenances[0];
    $('#replace-with-fetched-data').html(
      this.createTimeRangeTag(maint.scheduled_for, maint.scheduled_until),
    );
    $.fn.localizeTime();
  } else {
    $('#replace-with-fetched-data').html(
      '<em>(there are no active scheduled maintenances)</em>',
    );
  }
};

ErrorPage.prototype.handleStatusFetchFail = function (pageType) {
  $('#replace-with-fetched-data').html(
    '<em>(enter a valid Statuspage url)</em>',
  );
};

ErrorPage.prototype.fetchStatus = function (pageUrl, pageType) {
  // console.log('in app.js fetch');
  if (!pageUrl || !pageType || pageType == '404') return;

  let url = '',
    self = this;

  if (pageType == '503') {
    url = `${pageUrl}/api/v2/status.json`;
  } else {
    url = `${pageUrl}/api/v2/scheduled-maintenances/active.json`;
  }

  $.ajax({
    type: 'GET',
    url,
  })
    .done((data, status) => {
      // console.log('success');
      self.handleStatusFetchSuccess(pageType, data);
    })
    .fail((xhr, msg) => {
      // console.log('fail');
      self.handleStatusFetchFail(pageType);
    });
};

export default ErrorPage;
